<script lang="ts">
  import { writable } from 'svelte/store'
  import { useNavigate } from 'svelte-navigator'
  import Dropdown from 'sv-bootstrap-dropdown'
  import { Modal } from 'svelte-simple-modal'

  import AboutModal from './AboutModal.svelte'
  import { ROUTES } from '../constants/constants'

  let aboutModal = writable(null)

  export let selected
  let dropdownTitle = selected

  let dropdownTrigger

  const navigate = useNavigate()
</script>

<Modal
  show={$aboutModal}
  styleContent={{ padding: '1.5rem' }}
  styleCloseButton={{ boxShadow: 'none', background: '#e4e4e4' }}
/>

<div class="main-dropdown">
  <Dropdown
    triggerElement={dropdownTrigger}
    onOpened={() => {
      dropdownTitle = 'Sezioni'
    }}
    onClosed={() => {
      dropdownTitle = selected
    }}
  >
    <button
      class="dropdown-current-label"
      type="button"
      bind:this={dropdownTrigger}
      style={dropdownTitle === 'Sezioni' ? 'color: #7b7b7b' : 'color: white'}
    >
      {dropdownTitle}<svg
        width="28"
        height="13"
        viewBox="0 0 28 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 2H26" stroke="white" stroke-width="3" stroke-linecap="round" />
        <path d="M10 10.793L26 10.793" stroke="white" stroke-width="3" stroke-linecap="round" />
      </svg>
    </button>
    <div slot="DropdownMenu" class="dropdown-items">
      <button
        class="dropdown-item"
        type="button"
        on:click={() => {
          navigate(`/`)
        }}
        >Home<svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4682 0L10.365 1.10557L14.7308 5.48864L0.272949 5.48864L0.272949 7.05682L14.7308 7.05682L10.365 11.4399L11.4682 12.5455L17.7275 6.27273L11.4682 0Z"
            fill="#7B7B7B"
          />
        </svg></button
      >

      <button
        class="dropdown-item"
        type="button"
        on:click={() => {
          navigate(`/${ROUTES.dataWall}`)
        }}
        style={selected === 'Ritratti di mobilità' ? 'color: white; font-weight: 600' : null}
        >Ritratti di mobilità<svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4682 0L10.365 1.10557L14.7308 5.48864L0.272949 5.48864L0.272949 7.05682L14.7308 7.05682L10.365 11.4399L11.4682 12.5455L17.7275 6.27273L11.4682 0Z"
            fill="#7B7B7B"
          />
        </svg></button
      >

      <button
        class="dropdown-item"
        type="button"
        on:click={() => {
          navigate(`/${ROUTES.results}`)
        }}
        style={selected === 'Risultati del sondaggio' ? 'color: white; font-weight: 600' : null}
        >Risultati del sondaggio<svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4682 0L10.365 1.10557L14.7308 5.48864L0.272949 5.48864L0.272949 7.05682L14.7308 7.05682L10.365 11.4399L11.4682 12.5455L17.7275 6.27273L11.4682 0Z"
            fill="#7B7B7B"
          />
        </svg></button
      >

      <button
        class="dropdown-item"
        type="button"
        on:click={() => {
          navigate(`/${ROUTES.insights}`)
        }}
        style={selected === 'Analisi delle risposte' ? 'color: white; font-weight: 600' : null}
        >Analisi delle risposte<svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4682 0L10.365 1.10557L14.7308 5.48864L0.272949 5.48864L0.272949 7.05682L14.7308 7.05682L10.365 11.4399L11.4682 12.5455L17.7275 6.27273L11.4682 0Z"
            fill="#7B7B7B"
          />
        </svg></button
      >

      <button
        class="dropdown-item"
        type="button"
        on:click={() => {
          navigate(`/${ROUTES.bestPractices}`)
        }}
        style={selected === 'Buone pratiche' ? 'color: white; font-weight: 600' : null}
        >Buone pratiche<svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4682 0L10.365 1.10557L14.7308 5.48864L0.272949 5.48864L0.272949 7.05682L14.7308 7.05682L10.365 11.4399L11.4682 12.5455L17.7275 6.27273L11.4682 0Z"
            fill="#7B7B7B"
          />
        </svg></button
      >

      <button
        class="dropdown-item"
        type="button"
        on:click={() => {
          navigate(`/${ROUTES.usefulResources}`)
        }}
        style={selected === 'Migliora il tuo impatto' ? 'color: white; font-weight: 600' : null}
        >Migliora il tuo impatto<svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4682 0L10.365 1.10557L14.7308 5.48864L0.272949 5.48864L0.272949 7.05682L14.7308 7.05682L10.365 11.4399L11.4682 12.5455L17.7275 6.27273L11.4682 0Z"
            fill="#7B7B7B"
          />
        </svg></button
      >

      <button
        class="dropdown-item"
        type="button"
        on:click={() => {
          navigate(`/${ROUTES.privacyPolicy}`)
        }}
        style={selected === 'Privacy policy' ? 'color: white; font-weight: 600' : null}
        >Privacy policy<svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4682 0L10.365 1.10557L14.7308 5.48864L0.272949 5.48864L0.272949 7.05682L14.7308 7.05682L10.365 11.4399L11.4682 12.5455L17.7275 6.27273L11.4682 0Z"
            fill="#7B7B7B"
          />
        </svg></button
      >

      <button class="dropdown-item chi-siamo" on:click={() => aboutModal.set(AboutModal)}
        >Chi siamo</button
      >
    </div>
  </Dropdown>
</div>

<style>
  @import url('https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css');

  :global(.main-dropdown .dropdown) {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
  }
  :global(.main-dropdown .dropdown-menu) {
    background-color: #313131;
    transform: translateY(55px) !important;
    padding: 0 0 2rem;
  }

  .dropdown-items {
    display: flex;
    flex-direction: column;
  }

  .dropdown-current-label,
  .dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100vw;
    margin: 0;
    background: #313131;
    border: none;
    border-radius: 0;
    color: #ffffff;
    text-align: left;
  }

  .dropdown-current-label {
    height: 55px;
    font-size: 22px;
    font-weight: 600;
    padding: 0.4rem 2rem;
  }

  .dropdown-item {
    font-size: 20px;
    color: #7b7b7b;
    padding: 1.5rem 2rem;
  }

  button:not(:disabled):active {
    background-color: #313131;
  }

  button:hover {
    cursor: pointer;
  }

  .chi-siamo {
    width: max-content;
    height: max-content;
    color: inherit;
    border: none;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    font-size: 12px;
    margin: 1.5rem 2rem;
    padding: 0.3rem 0.5rem;
    background-color: #595959;
    border-radius: 50px;
  }
</style>
